import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/styles';
import {
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Typography,
  IconButton,
  TextField,
  Grid
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/AddCircleTwoTone';
import RemoveIcon from '@material-ui/icons/RemoveCircleTwoTone';

import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';

import withAlert from '../../../../hoc/withAlert';
import {
  getEventeatingByDateAndEatingSelector,
  addEventeatingMeal,
  deleteEventeatingMeal
} from '../../../../store/eventeating';

import { getMealSelector } from '../../../../store/meal';

import {
  addCoupon,
  deleteCoupon,
  getPrice,
  getTicketCouponsSelector,
  getTicketCouponsByEatingSelector,
  getTicketCustomerTypeSelector,
  getTicketCustomerIdSelector,
  changeCoupon
} from '../../../../store/ticket';

import OrderContext from '../../../../context/orderContext';

const useStyles = makeStyles(theme => ({
  nestedHead: {
    // paddingLeft: theme.spacing(4),
  },
  nested: {
    // paddingLeft: theme.spacing(6),
  },
  weekend: {
    backgroundColor: '#e0f2f1'
  },
  listItemText: {
    fontSize: 13
  }
}));

const Eating = props => {
  const {
    name,
    meetingId,
    date,
    eating,
    setSnackMessage,
    setSnackType,
    setOpenSnack
  } = props;

  const classes = useStyles();

  const mealData = useSelector(getMealSelector);
  const customerType = useSelector(getTicketCustomerTypeSelector);
  const customerId = useSelector(getTicketCustomerIdSelector);
  const eventeatings = useSelector(
    getEventeatingByDateAndEatingSelector(meetingId, date, eating.id)
  );
  const coupons = useSelector(
    getTicketCouponsByEatingSelector(meetingId, date, eating.id)
  );

  // Сделал чтобы значение не менялось при каждом рендере, когда обонвляем амаунт в купонах. Не красиво.
  // const coupons = useMemo(() => {
  //   return getTicketCouponsByEatingSelector(meetingId, date, eating.id)(state)
  // }, [ticketCoupons])
  // console.log('coupons rerendaring',coupons);

  const dispatch = useDispatch();

  const [dishes, setDishes] = useState([]);

  const orderContext = useContext(OrderContext);
  // console.log('orderContext',orderContext);

  // Hooks
  useEffect(() => {
    if (eventeatings) {
      if (eventeatings.meals && eventeatings.meals.length > 0) {
        const chosenDishes = addCouponToDishes(
          mealData.filter(m => eventeatings.meals.includes(m.id)),
          coupons
        );
        setDishes(chosenDishes);
      }
    }
  }, [eventeatings, customerType]);

  // Handlers
  const handleMinus = async mealId => {
    if (orderContext.actionType === 'edit') {
      await dispatch(
        changeCoupon({
          action: 'delete',
          mealId,
          date,
          meetingId,
          ticketId: orderContext.ticketId,
          customerType,
          customerId
        })
      );
    }

    await dispatch(
      deleteCoupon({
        mealId,
        date,
        meetingId,
        eventeatingId: eventeatings.id,
        eatingId: eating.id
      })
    );
    setDishes(state =>
      dishes.map(d =>
        d.id === mealId ? { ...d, amount: d.amount > 1 ? d.amount - 1 : 0 } : d
      )
    );
  };

  // orderContext.ticketId, id, props.sessionId, date.split('.').join(""), 'add'
  const handleAdd = async mealId => {
    if (orderContext.actionType === 'edit') {
      await dispatch(
        changeCoupon({
          action: 'add',
          mealId,
          date,
          meetingId,
          ticketId: orderContext.ticketId,
          customerType,
          customerId
        })
      );
    }

    await dispatch(
      addCoupon({
        mealId,
        date,
        meetingId,
        eventeatingId: eventeatings.id,
        eatingId: eating.id
      })
    );
    setDishes(state =>
      dishes.map(d => (d.id === mealId ? { ...d, amount: d.amount + 1 } : d))
    );
  };

  // Helpers
  const addCouponToDishes = (dishesNew, couponsNew) => {
    return dishesNew.map(d => {
      const coupon = coupons ? couponsNew.filter(c => c.mealId == d.id) : [];
      const amount = coupon.length > 0 ? coupon[0].amount : 0;
      // console.log('customerType', customerType, d);
      const customerPrice = getPrice(customerType, d);
      // console.log('customerPrice', customerPrice);
      return {
        ...d,
        amount,
        customerPrice
      };
    });
  };

  return (
    <React.Fragment>
      <Typography variant="h5" style={{ fontSize: 14 }}>
        {name}
      </Typography>
      <Grid
        container
        direction="column"
        justify="flex-start"
        alignItems="flex-start">
        {dishes &&
          dishes.map(d => (
            <Grid item key={d.id}>
              <Grid
                container
                direction="row"
                justify="flex-start"
                alignItems="center"
                wrap="nowrap">
                <Grid item>
                  {/* <IconButton aria-label="minus" onClick={handleMinus(d.id)}> */}
                  <IconButton
                    aria-label="minus"
                    onClick={e => {
                      handleMinus(d.id);
                    }}>
                    <RemoveIcon fontSize="small" />
                  </IconButton>
                </Grid>
                <Grid item>
                  <Typography variant="h3" style={{ fontSize: 14 }}>
                    {' '}
                    {d.amount}{' '}
                  </Typography>
                </Grid>
                <Grid item>
                  {/* <IconButton aria-label="add" onClick={handleAdd(d.id)}> */}
                  <IconButton
                    aria-label="add"
                    onClick={e => {
                      handleAdd(d.id);
                    }}>
                    <AddIcon fontSize="small" />
                  </IconButton>
                </Grid>
                <Grid item zeroMinWidth>
                  <Typography
                    noWrap
                    style={{
                      paddingLeft: 10
                    }}>{`${d.customerPrice}฿ — ${d.name}`}</Typography>
                </Grid>
              </Grid>
            </Grid>
          ))}
      </Grid>
    </React.Fragment>
  );
};

export default withAlert(Eating);
